module.exports = __webpack_public_path__ + "img/right-arrow.59004afd.svg";